// removed by extract-text-webpack-plugin
module.exports = {"Black":"#333D47","currentSetting":"G8a49a4"};